import { Box, Grid, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export default function StreetTeamFilters({
  title,
  description,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  filterActions,
}) {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ fontWeight: 700, fontSize: "1rem" }}>{title}</Typography>
        <Typography sx={{ fontWeight: 300, fontSize: "0.8rem" }}>{description}</Typography>
      </Box>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="From"
            value={dateFrom}
            onChange={setDateFrom}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="To"
            value={dateTo}
            onChange={setDateTo}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
        {filterActions ? (
          <Grid item xs={12} md="auto" sx={{ ml: { md: "auto" } }}>
            {filterActions}
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
}
